var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicationStatusClockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "clock",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4402",
    "data-name": "Rectangle 4402",
    width: 52,
    height: 52,
    transform: "translate(0 -0.069)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23783",
    "data-name": "Group 23783",
    transform: "translate(-0.021 0.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23782",
    "data-name": "Group 23782",
    transform: "translate(0.021 0.021)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22920",
    "data-name": "Path 22920",
    d: "M51.926,25.963q0-.473-.017-.942a25.963,25.963,0,0,0-51.892,0Q0,25.49,0,25.963C0,40.3,13.337,50.984,25.963,50.984c12.855,0,25.963-10.682,25.963-25.021",
    transform: "translate(-0.063 -0.063)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22921",
    "data-name": "Path 22921",
    d: "M25.963,271.73A25.962,25.962,0,0,1,.019,246.709c-.011.313-.019.627-.019.942a25.963,25.963,0,1,0,51.926,0c0-.316-.008-.629-.019-.942A25.962,25.962,0,0,1,25.963,271.73",
    transform: "translate(-0.063 -221.751)",
    fill: "#1c2448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22922",
    "data-name": "Path 22922",
    d: "M85.864,63.1a21.665,21.665,0,0,0-43.289,0c-.013.312,0,21.229,21.644,21.229S85.878,63.417,85.864,63.1",
    transform: "translate(-38.32 -38.146)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22923",
    "data-name": "Path 22923",
    d: "M64.047,267.431A21.664,21.664,0,0,1,42.4,246.709c-.013.313-.022.626-.022.942a21.665,21.665,0,0,0,43.329,0c0-.316-.008-.63-.022-.942A21.664,21.664,0,0,1,64.047,267.431Z",
    transform: "translate(-38.146 -221.751)",
    fill: "#d5e0f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22924",
    "data-name": "Path 22924",
    d: "M281.27,177.042a1.57,1.57,0,0,0-2.221.015l-3.685,3.736.37,1.779,1.721.573,3.829-3.882A1.57,1.57,0,0,0,281.27,177.042Z",
    transform: "translate(-247.5 -158.743)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22925",
    "data-name": "Path 22925",
    d: "M136.867,149.936l-8.357-7.447a1.57,1.57,0,1,0-2.089,2.345l8.522,7.594,1.776-.592Z",
    transform: "translate(-113.19 -127.743)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22926",
    "data-name": "Path 22926",
    d: "M270.556,267.9a.782.782,0,0,1-.5-.184l-9.946-8.355a.785.785,0,0,1,1.01-1.2l9.946,8.355a.785.785,0,0,1-.505,1.386Z",
    transform: "translate(-233.536 -231.874)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22927",
    "data-name": "Path 22927",
    d: "M215.1,221.938l1.466,1.307,1.883-.64-.1-1.98-1.323-1.179a4.331,4.331,0,0,0-1.925,2.491",
    transform: "translate(-193.35 -197.254)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22928",
    "data-name": "Path 22928",
    d: "M264.316,218.038l-1.247,1.264v2.481h1.964l1.374-1.393A4.336,4.336,0,0,0,264.316,218.038Z",
    transform: "translate(-236.452 -195.988)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22929",
    "data-name": "Path 22929",
    d: "M236,231.28a2.685,2.685,0,0,0-5.027,0,2.519,2.519,0,1,0,5.027,0Z",
    transform: "translate(-207.585 -206.322)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22930",
    "data-name": "Path 22930",
    d: "M232.223,248.451a2.684,2.684,0,0,1-2.513-1.741,2.683,2.683,0,1,0,5.026,0,2.684,2.684,0,0,1-2.513,1.741",
    transform: "translate(-206.322 -221.752)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22931",
    "data-name": "Path 22931",
    d: "M249.816,65.012V62.576a.787.787,0,1,0-1.573,0v2.437a.787.787,0,1,0,1.573,0",
    transform: "translate(-223.129 -55.585)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22932",
    "data-name": "Path 22932",
    d: "M248.243,411.457v2.437a.787.787,0,1,0,1.573,0v-2.437a.787.787,0,0,0-1.573,0Z",
    transform: "translate(-223.129 -369.083)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22933",
    "data-name": "Path 22933",
    d: "M413.893,249.816a.787.787,0,1,0,0-1.573h-2.437a.787.787,0,0,0,0,1.573Z",
    transform: "translate(-369.083 -223.129)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22934",
    "data-name": "Path 22934",
    d: "M62.576,248.243a.787.787,0,1,0,0,1.573h2.437a.787.787,0,1,0,0-1.573Z",
    transform: "translate(-55.585 -223.129)",
    fill: "#040227"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationStatusClockIcon);
export default __webpack_public_path__ + "static/media/application-status-clock-icon.0eb5b31039fc3a551900df6b60343d93.svg";
export { ForwardRef as ReactComponent };